import { min } from 'lodash'
import { govCertapplyConstants } from '../../../constants'

export const initialState = {
  screenURL: null,
  verifyIndiECDWResult: null,
  issueIndiECDWResult: null,

  data: null, // 신청 가능한 전자증명서 목록 result
  popupData: null, // 신청현황 result
  ECDApplyQFVerifyResult: null, // 신청자격확인 result
  ECDApplyResult: null, // 신청 result
  inquireIndiECDWPopupListResult: null, // 개인 전자문서지갑 팝업함 조회 result
  changeIndiECDWInfoResult: null, // 개인 전자문서지갑 주소 정보 변경 result
  inquireIndiStipAgreeResult: null, // 약관동의 내용 조회 result
  isLoading: false,
  isFailure: false,
  ECDApplyPopup: false,
}

// 전자문서지갑
export default function govcertapply(state = initialState, action) {
  switch (action.type) {
    /***************************************************************************
      지갑 화면 URL 요청
     ***************************************************************************/
    case govCertapplyConstants.SCREEN_URL_LOAD_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case govCertapplyConstants.SCREEN_URL_LOAD_SUCCESS:
      // console.log('지갑 화면 URL 요청', action.response?.payload)
      return {
        ...state,
        screenURL: action.response?.payload,
      }
    case govCertapplyConstants.SCREEN_URL_LOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }
    /***************************************************************************
      개인 전자문서지갑 주소 확인
     ***************************************************************************/
    case govCertapplyConstants.VERIFY_INDI_ECDW_LOAD_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case govCertapplyConstants.VERIFY_INDI_ECDW_LOAD_SUCCESS:
      // console.log('개인 전자문서지갑 주소 확인', action.response?.payload)
      return {
        ...state,
        verifyIndiECDWResult: action.response?.payload,
      }
    case govCertapplyConstants.VERIFY_INDI_ECDW_LOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }
    /***************************************************************************
      개인 전자문서지갑 주소 발급
     ***************************************************************************/
    case govCertapplyConstants.ISSUE_INDI_ECDW_LOAD_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case govCertapplyConstants.ISSUE_INDI_ECDW_LOAD_SUCCESS:
      // console.log('개인 전자문서지갑 주소 발급', action.response.payload)
      return {
        ...state,
        issueIndiECDWResult: action.response?.payload,
      }
    case govCertapplyConstants.ISSUE_INDI_ECDW_LOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }
    /***************************************************************************
      개인 전자문서지갑 팝업함 조회
     ***************************************************************************/
    case govCertapplyConstants.INQUIRE_INDI_ECDW_POPUP_LIST_LOAD_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case govCertapplyConstants.INQUIRE_INDI_ECDW_POPUP_LIST_LOAD_SUCCESS:
      // console.log('개인 전자문서지갑 팝업함 조회', action.response.payload)
      return {
        ...state,
        inquireIndiECDWPopupListResult: action.response?.payload,
      }
    case govCertapplyConstants.INQUIRE_INDI_ECDW_POPUP_LIST_LOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }
    /***************************************************************************
      개인 전자문서지갑 주소 정보 변경
     ***************************************************************************/
    case govCertapplyConstants.CHANGE_INDI_ECDW_INFO_LOAD_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case govCertapplyConstants.CHANGE_INDI_ECDW_INFO_LOAD_SUCCESS:
      // console.log('개인 전자문서지갑 주소 정보 변경', action.response.payload)
      return {
        ...state,
        changeIndiECDWInfoResult: action.response?.payload,
      }
    case govCertapplyConstants.CHANGE_INDI_ECDW_INFO_LOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }
    /***************************************************************************
      약관동의 내용 조회
     ***************************************************************************/
    case govCertapplyConstants.INQUIRE_INDI_STIP_AGREE_LOAD_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case govCertapplyConstants.INQUIRE_INDI_STIP_AGREE_LOAD_SUCCESS:
      // console.log('약관동의 내용 조회', action.response.payload)
      return {
        ...state,
        inquireIndiStipAgreeResult: action.response?.payload,
      }
    case govCertapplyConstants.INQUIRE_INDI_STIP_AGREE_LOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }
    /***************************************************************************
      전자증명서 유통 서비스가 지원하는 전자증명서 종류 및 관련 정보 목록 조회
     ***************************************************************************/
    case govCertapplyConstants.LOAD_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case govCertapplyConstants.LOAD_SUCCESS:
      return {
        ...state,
        data: action.response.data?.payload,
      }
    case govCertapplyConstants.LOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }
    /***************************************************************************
      증명서 신청 자격 확인
     ***************************************************************************/
    case govCertapplyConstants.ECD_APPLY_QF_VERIFY_LOAD_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case govCertapplyConstants.ECD_APPLY_QF_VERIFY_LOAD_SUCCESS:
      return {
        ...state,
        ECDApplyQFVerifyResult: action.response?.payload,
      }
    case govCertapplyConstants.ECD_APPLY_QF_VERIFY_LOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }
    /***************************************************************************
      증명서 신청
     ***************************************************************************/
    case govCertapplyConstants.ECD_APPLY_LOAD_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case govCertapplyConstants.ECD_APPLY_LOAD_SUCCESS:
      return {
        ...state,
        ECDApplyResult: action.response?.payload,
      }
    case govCertapplyConstants.ECD_APPLY_LOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }
    /***************************************************************************
      증명서 신청 목록 조회(증명서 신청현황)
     ***************************************************************************/
    case govCertapplyConstants.INQUIRE_LOAD_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case govCertapplyConstants.INQUIRE_LOAD_SUCCESS:
      return {
        ...state,
        popupData: action.response.data?.payload,
      }
    case govCertapplyConstants.INQUIRE_LOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }
    /***************************************************************************
      증명서 신청현황 POPUP
     ***************************************************************************/
    case govCertapplyConstants.SHOW_POPUP_ITEMS:
      return {
        ...state,
        ECDApplyPopup: true,
      }
    case govCertapplyConstants.CLOSE_POPUP_ITEMS:
      return {
        ...state,
        ECDApplyPopup: false,
      }
    default:
      return state
  }
}
